module.exports = __webpack_public_path__ + "img/album13_08.24533bdb.jpg";